import { Injectable, inject } from '@angular/core';
import { RegexService } from '../services/regex.service';
import { UtilsService } from '../services/utils.service';

@Injectable({ providedIn: 'root' })
export class RegexServiceInitiatedGuard {
  private readonly regex = inject(RegexService);
  protected readonly utils = inject(UtilsService);

  async canActivate(): Promise<boolean> {
    await this.isRegexServiceInitiated();
    return true;
  }

  private async isRegexServiceInitiated(): Promise<boolean> {
    if (this.regex.isInitiated()) {
      return true;
    }

    await this.utils.sleep(500);
    return await this.isRegexServiceInitiated();
  }
}
